export const Tech = [

    {
      title: "<img style='background-color:#fff;border-radius:10px;padding:5px;' src='https://profilinator.rishav.dev/skills-assets/dot-net-original-wordmark.svg' alt='.NET' height='50' /> Desktop Apps and Windows Services ",
      tenure: "Winforms ",
      details: "<ul><li>VB.NET</li><li>C#</li></ul>",
      others: ""
    },
    {
      title: "<img style='background-color:#fff;border-radius:10px;padding:5px;' src='https://profilinator.rishav.dev/skills-assets/javascript-original.svg' alt='Javascript' height='50' /> Web Apps",
      tenure: "",
      details: "<ul><li>HTML</li><li>CSS</li><li>Javascript</li><li>React JS</li></ul>",
      others: ""
    },
    {
      title: "<img style='background-color:#fff;border-radius:10px;padding:5px;' src='https://profilinator.rishav.dev/skills-assets/react-original-wordmark.svg' alt='React' height='50' /> Backend",
      tenure: "",
      details: "<ul><li>Node JS</li><li>PHP</li><li>ASP.NET</li><li>Java</li></ul>",
      others: ""
    },
    {
      title: "<img style='background-color:#fff;border-radius:10px;padding:5px;' src='https://profilinator.rishav.dev/skills-assets/mysql-original-wordmark.svg' alt='MySQL' height='50' /> Database",
      tenure: "",
      details: "<ul><li>MySQL</li><li>SQLite</li></ul>",
      others: ""
    },
    {
      title: "<img style='background-color:#fff;border-radius:10px;padding:5px;' src='https://profilinator.rishav.dev/skills-assets/git-scm-icon.svg' alt='DevOps' height='50' /> DevOps",
      tenure: "",
      details: "<ul><li>Azure DevOps</li><li>Git</li><li>Github</li><li>Bash</li></ul>",
      others: ""
    },
    {
      title: "<img style='background-color:#fff;border-radius:10px;padding:5px;' src='https://profilinator.rishav.dev/skills-assets/linux-original.svg' alt='Linux' height='50' /> Environment / OS",
      tenure: "",
      details: "<ul><li>Windows</li><li>Linux</li><li>AWS</li></ul>",
      others: ""
    }
];
  
  
  